import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ViewBaseComponent } from '../view-base/view-base.component';

@Component({
  selector: 'view-icons',
  templateUrl: './view-icons.component.html',
  styleUrls: ['./view-icons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewIconsComponent extends ViewBaseComponent {}
